import React from 'react';
import UpdateWarning from './updateWarning/updateWarning';
import UpdateDanger from './updateDanger/updateDanger';
import UpdateDark from './updateDark/updateDark';

export const columns = [
  {
    //0
    name: 'id',
    label: '',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
    },
  },

  {
    //1
    name: 'contract_item',
    label: 'Nome',
    options: {
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return value.nickname;
      },
    },
  },
  {
    //2
    name: 'contract_item',
    label: 'Serial',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return value.serial;
      },
    },
  },
  {
    //3
    name: 'contract_item',
    label: 'Contrato',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return value.contract.name;
      },
    },
  },

  {
    //4
    name: 'id_user',
    label: '',
    options: {
      filter: false,
      sort: false,
      display: 'excluded',
    },
  },

  {
    //5
    name: 'warning',
    label: 'Alerta Médio',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return (
          <UpdateWarning
            id={tableMeta.rowData[0]}
            activeDefault={value}
            idUser={tableMeta.rowData[4]}
            page={tableMeta.tableState.page}
            rowsPage={tableMeta.tableState.rowsPerPage}
            search={
              !tableMeta.tableState.search ? '' : tableMeta.tableState.search
            }
          />
        );
      },
    },
  },

  {
    //6
    name: 'danger',
    label: 'Alerta Urgente',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return (
          <UpdateDanger
            id={tableMeta.rowData[0]}
            activeDefault={value}
            idUser={tableMeta.rowData[4]}
            page={tableMeta.tableState.page}
            rowsPage={tableMeta.tableState.rowsPerPage}
            search={
              !tableMeta.tableState.search ? '' : tableMeta.tableState.search
            }
          />
        );
      },
    },
  },

  {
    //6
    name: 'dark',
    label: 'Alerta Crítico',
    options: {
      print: false,
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellProps: () => ({
        style: {
          'text-align': 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          'text-align': 'center',
          width: '30%',
        },
      }),
      filter: true,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        return (
          <UpdateDark
            id={tableMeta.rowData[0]}
            activeDefault={value}
            idUser={tableMeta.rowData[4]}
            page={tableMeta.tableState.page}
            rowsPage={tableMeta.tableState.rowsPerPage}
            search={
              !tableMeta.tableState.search ? '' : tableMeta.tableState.search
            }
          />
        );
      },
    },
  },
];
